import type { RgbaHex } from "./types";

const RGBA_PATTERN = /^#[0-9a-fA-F]{8}$/;

export type RgbaTuple = readonly [
  red: number,
  green: number,
  blue: number,
  alpha: number,
];

export function isRgbaHex(value: unknown): value is RgbaHex {
  return typeof value === "string" && RGBA_PATTERN.test(value);
}

export function normalizeRgbaHex(value: string): RgbaHex {
  if (!isRgbaHex(value)) {
    throw new TypeError(`颜色必须使用 #RRGGBBAA 格式，收到：${value}`);
  }
  return value.toUpperCase() as RgbaHex;
}

export function rgbaHexToTuple(value: string): RgbaTuple {
  const color = normalizeRgbaHex(value);
  return [
    Number.parseInt(color.slice(1, 3), 16),
    Number.parseInt(color.slice(3, 5), 16),
    Number.parseInt(color.slice(5, 7), 16),
    Number.parseInt(color.slice(7, 9), 16),
  ];
}

export function rgbaTupleToHex(
  red: number,
  green: number,
  blue: number,
  alpha: number,
): RgbaHex {
  const channels = [red, green, blue, alpha].map((channel) => {
    if (!Number.isInteger(channel) || channel < 0 || channel > 255) {
      throw new RangeError(`RGBA 通道必须是 0 到 255 的整数，收到：${channel}`);
    }
    return channel.toString(16).padStart(2, "0");
  });
  return `#${channels.join("").toUpperCase()}` as RgbaHex;
}

export function colorsEqual(left: RgbaTuple, right: RgbaTuple): boolean {
  return (
    left[0] === right[0] &&
    left[1] === right[1] &&
    left[2] === right[2] &&
    left[3] === right[3]
  );
}
